import React from 'react';
import './FinancialDashboard.css';

const FinancialControls = ({ 
  horizonteTemporal, 
  setHorizonteTemporal, 
  tipoVolumen, 
  setTipoVolumen,
  fuentePrecio,
  setFuentePrecio,
  recalculating = false,
  lastUpdate = null
}) => {
  const horizonteOptions = [
    { value: 'Mensual', label: 'Mensual (1x)', description: 'Cálculos basados en 1 mes' },
    { value: 'Trimestral', label: 'Trimestral (3x)', description: 'Cálculos basados en 3 meses' },
    { value: 'Semestral', label: 'Semestral (6x)', description: 'Cálculos basados en 6 meses' },
    { value: 'Anual', label: 'Anual (12x)', description: 'Cálculos basados en 12 meses' }
  ];
  
  const volumenOptions = [
    { 
      value: 'Predicciones', 
      label: 'Predicciones', 
      description: 'Promedio de los próximos 2 meses predichos',
      icon: '🔮'
    },
    { 
      value: 'Histórico', 
      label: 'Histórico', 
      description: 'Promedio de los últimos 6 meses',
      icon: '📊'
    },
    { 
      value: 'Promedio', 
      label: 'Promedio', 
      description: 'Combinación de histórico y predicciones',
      icon: '⚖️'
    }
  ];

  const fuentePrecioOptions = [
    { value: 'Publications (actual)', label: 'Publications (actual)', description: 'Precios actuales de GASHPE' },
    { value: 'Promedio 15 días', label: 'Promedio 15 días', description: 'Promedio de últimos 15 días desde concatenado histórico' },
    { value: 'Promedio 30 días', label: 'Promedio 30 días', description: 'Promedio de últimos 30 días desde concatenado histórico' },
    { value: 'Promedio 45 días', label: 'Promedio 45 días', description: 'Promedio de últimos 45 días desde concatenado histórico' },
    { value: 'Promedio 90 días', label: 'Promedio 90 días', description: 'Promedio de últimos 90 días desde concatenado histórico' }
  ];
  
  return (
    <div className="financial-controls">
      <div className="controls-header">
        <h3>⚙️ Configuración</h3>
      </div>
      
      <div className="controls-grid">
        {/* Control de Horizonte Temporal */}
        <div className="control-group">
          <label className="control-label">
            📅 Horizonte Temporal
            <span className="control-hint">
              Define el período para cálculos de utilidad total
            </span>
          </label>
          
          <div className="radio-group">
            {horizonteOptions.map(option => (
              <label 
                key={option.value} 
                className={`radio-option ${horizonteTemporal === option.value ? 'selected' : ''}`}
              >
                <input
                  type="radio"
                  name="horizonte_temporal"
                  value={option.value}
                  checked={horizonteTemporal === option.value}
                  onChange={(e) => setHorizonteTemporal(e.target.value)}
                />
                <div className="radio-content">
                  <span className="radio-label">{option.label}</span>
                  <span className="radio-description">{option.description}</span>
                </div>
              </label>
            ))}
          </div>
        </div>
        
        {/* Control de Tipo de Volumen */}
        <div className="control-group">
          <label className="control-label">
            📊 Tipo de Volumen
            <span className="control-hint">
              Seleccione la fuente de datos para volúmenes de venta
            </span>
          </label>
          
          <div className="button-group">
            {volumenOptions.map(option => (
              <button
                key={option.value}
                className={`btn-option ${tipoVolumen === option.value ? 'active' : ''}`}
                onClick={() => setTipoVolumen(option.value)}
                title={option.description}
              >
                <span className="btn-icon">{option.icon}</span>
                <div className="btn-text">
                  <span className="btn-label">{option.label}</span>
                  <span className="btn-description">{option.description}</span>
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Control de Fuente de Precio */}
        <div className="control-group">
          <label className="control-label">
            💵 Fuente de Precio Unitario
            <span className="control-hint">
              Seleccione cómo calcular el precio para utilidades
            </span>
          </label>
          
          <select 
            value={fuentePrecio} 
            onChange={(e) => setFuentePrecio(e.target.value)}
            className="fuente-select"
          >
            {fuentePrecioOptions.map(option => (
              <option key={option.value} value={option.value} title={option.description}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      
      <div className="current-config" style={{ fontSize: '0.85em', padding: '6px 0', color: '#888', textAlign: 'center' }}>
        <span>{horizonteTemporal}</span>
        <span style={{ margin: '0 8px' }}>•</span>
        <span>{tipoVolumen}</span>
        <span style={{ margin: '0 8px' }}>•</span>
        <span>{fuentePrecio}</span>
        {recalculating && (
          <span style={{ marginLeft: '12px', color: '#ff9800', fontWeight: 'bold' }}>
            ⏳ Recalculando...
          </span>
        )}
        {lastUpdate && !recalculating && (
          <span style={{ marginLeft: '12px', color: '#999', fontSize: '0.8em' }}>
            {new Date(lastUpdate).toLocaleTimeString()}
          </span>
        )}
      </div>
    </div>
  );
};

export default FinancialControls;

